import { render, staticRenderFns } from "./contect-menu-action.vue?vue&type=template&id=632a54ef"
import script from "./contect-menu-action.vue?vue&type=script&lang=js"
export * from "./contect-menu-action.vue?vue&type=script&lang=js"
import style0 from "./contect-menu-action.vue?vue&type=style&index=0&id=632a54ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports